<template>
  <div>
    <modal id="signSchedule" class="skintestblock" v-model="modal" :append-to-body="true"
           :backdrop="false">
      <h4 slot="title" class="smalltitle">Set new password</h4>
      <div class="prolabel">New Password</div>
      <div class="profield"><input v-model="newPassword" type="password" autofocus></div>

      <div slot="footer">
        <button type="button" class="btn btn-default" @click.prevent="updatePassword">
          <i class="fas fa-spinner fa-spin" v-if="processingStatus"></i> Set
        </button>
        <button type="button" class="btn btn-default" @click.prevent="closeModal">Close
        </button>
      </div>
    </modal>
  </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'SetNewPassword',
  components: { },
  props: {
    user: { required: true }
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      newPassword: '',
      processingStatus: false
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
  },
  beforeDestroy () {},
  methods: {
    async updatePassword () {
      if (this.processingStatus) {
        return
      }
      try {
        let data = {
          userId: this.user.id,
          newPassword: this.newPassword
        }
        this.processingStatus = true
        let response = await httpClient.put(`/users/set-new-password`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.closeModal()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error when set new password ')
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style scoped="">

</style>
